import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Truck, Banknote, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const FEATURE_ICONS = [Truck, Banknote, CreditCard];
const COVER_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_wholesale-hub-320/artifacts/l7mv85sm_zealous%20ventures%20COVER%202.png";

export default function HeroBanner() {
  const { site, user } = useAuth();
  const features = site.features || [];
  return (
    <>
      <section className="relative overflow-hidden bg-slate-900" data-testid="hero-banner">
        <img
          src={COVER_URL}
          alt="Zealous Ventures — brands in this catalogue"
          className="w-full max-h-[82vh] object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/20 to-transparent hidden sm:block" />

        <div className="relative sm:absolute inset-x-0 bottom-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-5 sm:pt-0 pb-7 md:pb-10 flex flex-col items-center text-center animate-fade-up">
            <div className="flex flex-wrap justify-center gap-3">
              <Button asChild size="lg" className="bg-[#FFDA00] hover:bg-[#f2ce00] text-slate-900 font-semibold rounded-full h-12 px-7 shadow-lg shadow-black/30">
                <Link to="/register" data-testid="hero-register-btn">
                  Open a wholesale account <ArrowRight className="h-4 w-4 ml-1.5" />
                </Link>
              </Button>
              {!user && (
                <Button asChild size="lg" className="bg-white hover:bg-slate-100 text-slate-900 font-semibold rounded-full h-12 px-7 shadow-lg shadow-black/30">
                  <Link to="/login" data-testid="hero-login-btn">Sign in</Link>
                </Button>
              )}
              <Button asChild size="lg" variant="outline" className="rounded-full h-12 px-7 bg-white/10 border-white/30 text-white hover:bg-white/20 hover:text-white backdrop-blur-sm">
                <a href="#catalogue" data-testid="hero-browse-btn">Browse catalogue</a>
              </Button>
            </div>
            <div
              className="mt-6 text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-white/90"
              data-testid="hero-tagline"
            >
              South India&rsquo;s Biggest Garment Distributor
            </div>
          </div>
        </div>
      </section>

      {features.length > 0 && (
        <section className="bg-white border-b border-slate-200" data-testid="hero-features">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {features.map((f, i) => {
              const Icon = FEATURE_ICONS[i] || Truck;
              return (
                <div key={i} className="flex items-start gap-3 rounded-xl bg-slate-50 border border-slate-100 p-4">
                  <div className="h-9 w-9 rounded-lg bg-[#FFDA00]/20 flex items-center justify-center shrink-0">
                    <Icon className="h-4.5 w-4.5 h-5 w-5 text-slate-800" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-slate-900">{f.title}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{f.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      )}
    </>
  );
}
